import {IndexRedirect, Route} from 'react-router';
import React from 'react';

import checkFeatureFlagStatusOnEnter from 'client/Routing/checkFeatureFlagStatusOnEnter';
import sessionStore from 'client/Session/SessionStore';
import StudentHomepage from './StudentHomepage';

const StudentHomepageRoutes = (
  <Route
    component={StudentHomepage}
    onEnter={(nextState, replace, callback) => {
      if (sessionStore.hasValidSession() && !sessionStore.isStudent()) {
        replace('/classes');
        callback?.();
        return;
      } else {
        return checkFeatureFlagStatusOnEnter('new_student_dashboard', '/classes', 'require')(
          nextState,
          replace,
          callback
        );
      }
    }}
    path='home'
  >
    <IndexRedirect to='assignments' />
    <Route path='(class/:classroomId/)assignments' component={() => <div>Assignments...</div>} />
    <Route path='(class/:classroomId/)skill-path' component={() => <div>Skill Path...</div>} />
    <Route
      path='(class/:classroomId/)independent-practice'
      component={() => <div>Independent Practice...</div>}
    />
  </Route>
);

export default StudentHomepageRoutes;
